/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BerthResponseDto } from '../model';
// @ts-ignore
import type { CancelVesselVisitCommand } from '../model';
// @ts-ignore
import type { CargoType } from '../model';
// @ts-ignore
import type { CarrierVisitStatus } from '../model';
// @ts-ignore
import type { CreateVesselVisitCommand } from '../model';
// @ts-ignore
import type { EndVesselVisitOperationCommand } from '../model';
// @ts-ignore
import type { ReactivateVesselVisitCommand } from '../model';
// @ts-ignore
import type { RevertCurrentStatusCommand } from '../model';
// @ts-ignore
import type { SyncVesselVisitsDto } from '../model';
// @ts-ignore
import type { UpdateVesselVisitBerthsCommand } from '../model';
// @ts-ignore
import type { UpdateVesselVisitBerthsDto } from '../model';
// @ts-ignore
import type { UpdateVesselVisitCommand } from '../model';
// @ts-ignore
import type { UpdateVesselVisitStatusCommand } from '../model';
// @ts-ignore
import type { UpsertOrderListCommandV2 } from '../model';
// @ts-ignore
import type { VesselVisitDto } from '../model';
// @ts-ignore
import type { VesselVisitDtoPaginatedList } from '../model';
// @ts-ignore
import type { VesselVisitUpdatedDto } from '../model';
/**
 * VesselVisitsApi - axios parameter creator
 */
export const VesselVisitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        berths: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('berths', 'id', id)
            const localVarPath = `/planning/api/VesselVisits/{id}/Berths`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CancelVesselVisitCommand} [cancelVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (cancelVesselVisitCommand?: CancelVesselVisitCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/VesselVisits/Cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelVesselVisitCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateVesselVisitCommand} [createVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createVesselVisitCommand?: CreateVesselVisitCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/VesselVisits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVesselVisitCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [portUnlocode] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVesselVisitDynamically: async (portUnlocode?: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/VesselVisits/CreateVesselVisitsDynamically`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (portUnlocode !== undefined) {
                localVarQueryParameter['portUnlocode'] = portUnlocode;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {CarrierVisitStatus} [status] 
         * @param {CargoType} [cargoType] 
         * @param {boolean} [includeCancelled] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (page: number, pageSize: number, status?: CarrierVisitStatus, cargoType?: CargoType, includeCancelled?: boolean, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('get', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('get', 'pageSize', pageSize)
            const localVarPath = `/planning/api/VesselVisits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (cargoType !== undefined) {
                localVarQueryParameter['CargoType'] = cargoType;
            }

            if (includeCancelled !== undefined) {
                localVarQueryParameter['IncludeCancelled'] = includeCancelled;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (includeCompleted !== undefined) {
                localVarQueryParameter['IncludeCompleted'] = includeCompleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (isDescending !== undefined) {
                localVarQueryParameter['IsDescending'] = isDescending;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getById', 'id', id)
            const localVarPath = `/planning/api/VesselVisits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (ids: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('getByIds', 'ids', ids)
            const localVarPath = `/planning/api/VesselVisits/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (ids) {
                localVarQueryParameter['Ids'] = ids;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {EndVesselVisitOperationCommand} [endVesselVisitOperationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationEnd: async (id: number, endVesselVisitOperationCommand?: EndVesselVisitOperationCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('operationEnd', 'id', id)
            const localVarPath = `/planning/api/VesselVisits/{id}/OperationEnd`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(endVesselVisitOperationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertOrderListCommandV2} [upsertOrderListCommandV2] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        orders: async (upsertOrderListCommandV2?: UpsertOrderListCommandV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/VesselVisits/Orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertOrderListCommandV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateVesselVisitCommand} [updateVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put: async (updateVesselVisitCommand?: UpdateVesselVisitCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/VesselVisits/Put`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVesselVisitCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReactivateVesselVisitCommand} [reactivateVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivate: async (reactivateVesselVisitCommand?: ReactivateVesselVisitCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/VesselVisits/Reactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reactivateVesselVisitCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {RevertCurrentStatusCommand} [revertCurrentStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertCurrentStatus: async (id: number, revertCurrentStatusCommand?: RevertCurrentStatusCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('revertCurrentStatus', 'id', id)
            const localVarPath = `/planning/api/VesselVisits/{id}/RevertCurrentStatus`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revertCurrentStatusCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sync: async (from?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/VesselVisits/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateVesselVisitBerthsCommand} [updateVesselVisitBerthsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBerths: async (id: number, updateVesselVisitBerthsCommand?: UpdateVesselVisitBerthsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBerths', 'id', id)
            const localVarPath = `/planning/api/VesselVisits/{id}/Berths`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVesselVisitBerthsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateVesselVisitStatusCommand} [updateVesselVisitStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVesselVisitStatus: async (id: number, updateVesselVisitStatusCommand?: UpdateVesselVisitStatusCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateVesselVisitStatus', 'id', id)
            const localVarPath = `/planning/api/VesselVisits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVesselVisitStatusCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertOrderListCommandV2} [upsertOrderListCommandV2] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        upsertOrderList: async (upsertOrderListCommandV2?: UpsertOrderListCommandV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/VesselVisits/UpsertOrderListAsync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertOrderListCommandV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VesselVisitsApi - functional programming interface
 */
export const VesselVisitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VesselVisitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async berths(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BerthResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.berths(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.berths']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CancelVesselVisitCommand} [cancelVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(cancelVesselVisitCommand?: CancelVesselVisitCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(cancelVesselVisitCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateVesselVisitCommand} [createVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createVesselVisitCommand?: CreateVesselVisitCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VesselVisitDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createVesselVisitCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [portUnlocode] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVesselVisitDynamically(portUnlocode?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVesselVisitDynamically(portUnlocode, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.createVesselVisitDynamically']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {CarrierVisitStatus} [status] 
         * @param {CargoType} [cargoType] 
         * @param {boolean} [includeCancelled] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(page: number, pageSize: number, status?: CarrierVisitStatus, cargoType?: CargoType, includeCancelled?: boolean, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VesselVisitDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(page, pageSize, status, cargoType, includeCancelled, filter, includeCompleted, orderBy, isDescending, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VesselVisitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(ids: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VesselVisitDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {EndVesselVisitOperationCommand} [endVesselVisitOperationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operationEnd(id: number, endVesselVisitOperationCommand?: EndVesselVisitOperationCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operationEnd(id, endVesselVisitOperationCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.operationEnd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertOrderListCommandV2} [upsertOrderListCommandV2] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async orders(upsertOrderListCommandV2?: UpsertOrderListCommandV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orders(upsertOrderListCommandV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.orders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateVesselVisitCommand} [updateVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async put(updateVesselVisitCommand?: UpdateVesselVisitCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VesselVisitUpdatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.put(updateVesselVisitCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.put']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReactivateVesselVisitCommand} [reactivateVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivate(reactivateVesselVisitCommand?: ReactivateVesselVisitCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivate(reactivateVesselVisitCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.reactivate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {RevertCurrentStatusCommand} [revertCurrentStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revertCurrentStatus(id: number, revertCurrentStatusCommand?: RevertCurrentStatusCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revertCurrentStatus(id, revertCurrentStatusCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.revertCurrentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async sync(from?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncVesselVisitsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sync(from, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.sync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateVesselVisitBerthsCommand} [updateVesselVisitBerthsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBerths(id: number, updateVesselVisitBerthsCommand?: UpdateVesselVisitBerthsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateVesselVisitBerthsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBerths(id, updateVesselVisitBerthsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.updateBerths']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateVesselVisitStatusCommand} [updateVesselVisitStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVesselVisitStatus(id: number, updateVesselVisitStatusCommand?: UpdateVesselVisitStatusCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVesselVisitStatus(id, updateVesselVisitStatusCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.updateVesselVisitStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertOrderListCommandV2} [upsertOrderListCommandV2] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async upsertOrderList(upsertOrderListCommandV2?: UpsertOrderListCommandV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertOrderList(upsertOrderListCommandV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselVisitsApi.upsertOrderList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VesselVisitsApi - factory interface
 */
export const VesselVisitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VesselVisitsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        berths(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<BerthResponseDto>> {
            return localVarFp.berths(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CancelVesselVisitCommand} [cancelVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(cancelVesselVisitCommand?: CancelVesselVisitCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancel(cancelVesselVisitCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateVesselVisitCommand} [createVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createVesselVisitCommand?: CreateVesselVisitCommand, options?: RawAxiosRequestConfig): AxiosPromise<Array<VesselVisitDto>> {
            return localVarFp.create(createVesselVisitCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [portUnlocode] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVesselVisitDynamically(portUnlocode?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createVesselVisitDynamically(portUnlocode, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {CarrierVisitStatus} [status] 
         * @param {CargoType} [cargoType] 
         * @param {boolean} [includeCancelled] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(page: number, pageSize: number, status?: CarrierVisitStatus, cargoType?: CargoType, includeCancelled?: boolean, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<VesselVisitDtoPaginatedList> {
            return localVarFp.get(page, pageSize, status, cargoType, includeCancelled, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<VesselVisitDto> {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(ids: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Array<VesselVisitDto>> {
            return localVarFp.getByIds(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {EndVesselVisitOperationCommand} [endVesselVisitOperationCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operationEnd(id: number, endVesselVisitOperationCommand?: EndVesselVisitOperationCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.operationEnd(id, endVesselVisitOperationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertOrderListCommandV2} [upsertOrderListCommandV2] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        orders(upsertOrderListCommandV2?: UpsertOrderListCommandV2, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.orders(upsertOrderListCommandV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateVesselVisitCommand} [updateVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put(updateVesselVisitCommand?: UpdateVesselVisitCommand, options?: RawAxiosRequestConfig): AxiosPromise<VesselVisitUpdatedDto> {
            return localVarFp.put(updateVesselVisitCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReactivateVesselVisitCommand} [reactivateVesselVisitCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivate(reactivateVesselVisitCommand?: ReactivateVesselVisitCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reactivate(reactivateVesselVisitCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {RevertCurrentStatusCommand} [revertCurrentStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertCurrentStatus(id: number, revertCurrentStatusCommand?: RevertCurrentStatusCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revertCurrentStatus(id, revertCurrentStatusCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [from] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sync(from?: string, options?: RawAxiosRequestConfig): AxiosPromise<SyncVesselVisitsDto> {
            return localVarFp.sync(from, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateVesselVisitBerthsCommand} [updateVesselVisitBerthsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBerths(id: number, updateVesselVisitBerthsCommand?: UpdateVesselVisitBerthsCommand, options?: RawAxiosRequestConfig): AxiosPromise<UpdateVesselVisitBerthsDto> {
            return localVarFp.updateBerths(id, updateVesselVisitBerthsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateVesselVisitStatusCommand} [updateVesselVisitStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVesselVisitStatus(id: number, updateVesselVisitStatusCommand?: UpdateVesselVisitStatusCommand, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.updateVesselVisitStatus(id, updateVesselVisitStatusCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertOrderListCommandV2} [upsertOrderListCommandV2] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        upsertOrderList(upsertOrderListCommandV2?: UpsertOrderListCommandV2, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.upsertOrderList(upsertOrderListCommandV2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VesselVisitsApi - object-oriented interface
 */
export class VesselVisitsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public berths(id: number, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).berths(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CancelVesselVisitCommand} [cancelVesselVisitCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancel(cancelVesselVisitCommand?: CancelVesselVisitCommand, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).cancel(cancelVesselVisitCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateVesselVisitCommand} [createVesselVisitCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public create(createVesselVisitCommand?: CreateVesselVisitCommand, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).create(createVesselVisitCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [portUnlocode] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createVesselVisitDynamically(portUnlocode?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).createVesselVisitDynamically(portUnlocode, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {CarrierVisitStatus} [status] 
     * @param {CargoType} [cargoType] 
     * @param {boolean} [includeCancelled] 
     * @param {string} [filter] 
     * @param {boolean} [includeCompleted] 
     * @param {string} [orderBy] 
     * @param {boolean} [isDescending] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public get(page: number, pageSize: number, status?: CarrierVisitStatus, cargoType?: CargoType, includeCancelled?: boolean, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).get(page, pageSize, status, cargoType, includeCancelled, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getById(id: number, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByIds(ids: Array<number>, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).getByIds(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {EndVesselVisitOperationCommand} [endVesselVisitOperationCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public operationEnd(id: number, endVesselVisitOperationCommand?: EndVesselVisitOperationCommand, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).operationEnd(id, endVesselVisitOperationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertOrderListCommandV2} [upsertOrderListCommandV2] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public orders(upsertOrderListCommandV2?: UpsertOrderListCommandV2, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).orders(upsertOrderListCommandV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateVesselVisitCommand} [updateVesselVisitCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public put(updateVesselVisitCommand?: UpdateVesselVisitCommand, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).put(updateVesselVisitCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReactivateVesselVisitCommand} [reactivateVesselVisitCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivate(reactivateVesselVisitCommand?: ReactivateVesselVisitCommand, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).reactivate(reactivateVesselVisitCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {RevertCurrentStatusCommand} [revertCurrentStatusCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revertCurrentStatus(id: number, revertCurrentStatusCommand?: RevertCurrentStatusCommand, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).revertCurrentStatus(id, revertCurrentStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [from] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public sync(from?: string, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).sync(from, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateVesselVisitBerthsCommand} [updateVesselVisitBerthsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBerths(id: number, updateVesselVisitBerthsCommand?: UpdateVesselVisitBerthsCommand, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).updateBerths(id, updateVesselVisitBerthsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateVesselVisitStatusCommand} [updateVesselVisitStatusCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateVesselVisitStatus(id: number, updateVesselVisitStatusCommand?: UpdateVesselVisitStatusCommand, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).updateVesselVisitStatus(id, updateVesselVisitStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertOrderListCommandV2} [upsertOrderListCommandV2] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public upsertOrderList(upsertOrderListCommandV2?: UpsertOrderListCommandV2, options?: RawAxiosRequestConfig) {
        return VesselVisitsApiFp(this.configuration).upsertOrderList(upsertOrderListCommandV2, options).then((request) => request(this.axios, this.basePath));
    }
}

